var map = {
	"./localhost/clientSettings.json": 64,
	"./nikkaren.ra-abas.jp/clientSettings.json": 65,
	"./saison.ra-abas.jp/clientSettings.json": 66,
	"./sompo-direct.ra-abas.jp/clientSettings.json": 67,
	"./sompo-japan.ra-abas.jp/clientSettings.json": 68,
	"./template/clientSettings.json": 69,
	"./zenjikyo.ra-abas.jp/clientSettings.json": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;